import classNames from 'classnames';
import * as React from 'react';
/**
 * GlyphLogo represents the logo Icon only. For a logo Icon + Watermark icon, see `WordmarkLogo`.
 *
 * See
 * [drl/dig/library/components/logos](https://dbx.link/dig/library/components/logos)
 * for more details.
 */
export const GlyphLogo = ({ className, size, 
// `src` is aliased as `GlyphComponent` for usage in JSX
src: GlyphComponent, ...rest }) => {
    const cls = classNames('dig-GlyphLogo', className);
    return React.createElement(GlyphComponent, { className: cls, width: size, height: size, focusable: "false", ...rest });
};
GlyphLogo.displayName = 'GlyphLogo';
